module.exports = __webpack_public_path__ + "media/images/back-8b3cfd05472728700a02165c8d50849c.svg";